import "nodelist-foreach-polyfill";

jQuery(document).ready(function () {
  var frontPageSwiperSettings = {
    centeredSlides: true,
    slidesPerView: "8",
    spaceBetween: 4,
    speed: 10000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    loop: true,
    longSwipes: false,
    shortSwipes: false,
    simulateTouch: false,
    breakpoints: {
      640: {
        slidesPerView: "4",
      },
    },
  };
  var swiper01 = new Swiper(".gallery-top", frontPageSwiperSettings);
  var swiper02 = new Swiper(".gallery-bottom", frontPageSwiperSettings);

  function resizeSlide(width) {
    const swiperSlides = document.querySelectorAll(".swiper-slide img");
    swiperSlides.forEach(function (item) {
      item.style.height = `${width}px`;
    });
  }
  jQuery(window).on("load resize", function () {
    var slides = document.getElementsByClassName("swiper-slide");
    if(slides.length>0){
      var slideWidth =
      document.getElementsByClassName("swiper-slide")[0].offsetWidth;
    resizeSlide(slideWidth);
    }
  });
});
